module.exports = __webpack_public_path__ + "media/stylesheets/images/talentz/icon_arrow_flow-08b7fa4cadbd888f7143e20516b4ca6f.png";